import { useEffect, useState, type FormEvent } from 'react'
import { getPortaria } from './portariaApi'

type AreaHour = { weekday: number; opensAt: string; closesAt: string }
const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']

export function AreaHoursEditor({ clientId, areaId, busy, onSave }: {
  clientId: string
  areaId: string
  busy: boolean
  onSave: (hours: AreaHour[]) => Promise<boolean>
}) {
  const [hours, setHours] = useState<AreaHour[]>([])
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const [validationError, setValidationError] = useState('')

  useEffect(() => {
    let current = true
    setLoading(true)
    setLoadError(false)
    getPortaria<AreaHour[]>(clientId, `areas/${areaId}/hours`)
      .then(value => { if (current) setHours(value) })
      .catch(() => { if (current) setLoadError(true) })
      .finally(() => { if (current) setLoading(false) })
    return () => { current = false }
  }, [clientId, areaId])

  function change(weekday: number, value: AreaHour | null) {
    setValidationError('')
    setHours(previous => [...previous.filter(hour => hour.weekday !== weekday), ...(value ? [value] : [])]
      .sort((a, b) => a.weekday - b.weekday))
  }

  async function save(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (loading || busy || loadError) return
    if (hours.some(hour => hour.opensAt >= hour.closesAt)) {
      setValidationError('O horário de fechamento deve ser posterior ao de abertura.')
      return
    }
    await onSave(hours)
  }

  return <form className="portaria-area-hours" onSubmit={event => void save(event)}>
    <strong>Horários de funcionamento</strong>
    {loading ? <p>Carregando horários…</p> : days.map((day, weekday) => {
      const hour = hours.find(value => value.weekday === weekday)
      return <div className="portaria-area-hour" key={weekday}>
        <label><input type="checkbox" checked={!!hour} disabled={busy || loadError}
          onChange={event => change(weekday, event.target.checked
            ? { weekday, opensAt: '08:00', closesAt: '22:00' } : null)} /> {day}</label>
        {hour && <><label>Abre<input type="time" required value={hour.opensAt} disabled={busy || loadError}
          onChange={event => change(weekday, { ...hour, opensAt: event.target.value })} /></label>
          <label>Fecha<input type="time" required value={hour.closesAt} disabled={busy || loadError}
            onChange={event => change(weekday, { ...hour, closesAt: event.target.value })} /></label></>}
      </div>
    })}
    {loadError && <p role="alert">Não foi possível carregar os horários desta área.</p>}
    {validationError && <p role="alert">{validationError}</p>}
    <button disabled={busy || loading || loadError}>Salvar horários</button>
  </form>
}
